import Image from 'next/future/image';
import React from 'react';
import Link from 'next/link';
import { Breakpoints } from 'settings/breakpoints';
import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import ProductBoxBig from '../collections/ProductBoxBig';
import plus_black from '@/public/icons/homepage/plus.svg';
import Slider from '../slider/Slider';

import HotDealCard from '../collections/hotDeals/HotDealCard';
import { TopDealProduct } from '@/lib/hot-deals/helpers';
import { getOfferUri } from '@/lib/offer';

const hotDealBreakpoints = {
  [Breakpoints.NONE]: {
    slidesPerView: 1.25,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.XS]: {
    slidesPerView: 1.75,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.SM]: {
    slidesPerView: 2.25,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.MD]: {
    slidesPerView: 2.75,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.LG]: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 10,
  },
  [Breakpoints.XL]: {
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: 10,
  },
};

const breakpoints = {
  [Breakpoints.NONE]: {
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.XS]: {
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.MD]: {
    slidesPerView: 3.5,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.LG]: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 10,
  },
  [Breakpoints.XL]: {
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: 10,
  },
};

export type CollectionSummaryData = { handle: string };

export default function CollectionSlider(props: {
  title: string;
  dealTitle: string;
  collectionHandle: string;
  offers: SearchOffers[];
  hideViewAll?: boolean;
  addShadow?: boolean;
  deals?: TopDealProduct[];
  displayPrice?: boolean;
}) {
  const {
    title,
    dealTitle,
    collectionHandle,
    offers,
    hideViewAll,
    addShadow,
    deals,
    displayPrice,
  } = props;
  const isHotDeals = collectionHandle === 'hot-deals';

  return (
    <div>
      <h2 className="flex items-center text-lg font-semibold md:text-xl">
        {title}
      </h2>
      {/* Need to have loading otherwise slider will render few times and inject some bug */}
      <div className="relative mt-3 sm:mt-4 md:mt-5">
        <Slider
          breakpoints={isHotDeals ? hotDealBreakpoints : breakpoints}
          speed={300}
        >
          {!isHotDeals
            ? offers.map((c, i) => (
                <ProductBoxBig
                  key={c.handle}
                  title={c.title.split(' - ')?.[0]}
                  url={getOfferUri(c)}
                  image={c.imageSrc}
                  price={c.price}
                  addShadow={addShadow}
                  sectionName={title}
                  cardIndex={Number(i)}
                  displayPrice={displayPrice}
                />
              ))
            : deals &&
              deals.map((deal, index) => (
                <HotDealCard
                  index={index}
                  deal={deal}
                  isSlider
                  key={deal.handle}
                />
              ))}
          {!hideViewAll && (
            <div className="h-full w-full rounded-md bg-teal-500 p-5 text-gray-700">
              <Link href={`/collections/${collectionHandle}`} passHref>
                <a className="flex h-full w-full flex-col items-center justify-center duration-500 ease-in-out will-change-contents hover:scale-105">
                  <div className="block h-6 w-6 xs:h-7 xs:w-7">
                    <Image
                      src={plus_black}
                      alt={`${dealTitle}-link`}
                      className="w-full"
                    />
                  </div>
                  <p className="mt-4 text-center text-xs font-bold !leading-4 xxs:text-sm xs:!leading-5 sm:text-base">
                    {dealTitle}
                  </p>
                </a>
              </Link>
            </div>
          )}
        </Slider>
      </div>
    </div>
  );
}
